import React, { Component } from 'react';
import _ from 'lodash';
import * as QuizHelpers from '../../helpers/quiz';

class Allowance extends Component {
  state = {
    animate: ''
  }

  componentDidMount () {
    const p = _.clone(this.props);
    QuizHelpers.sendAnalyticsOnQuestion(`${p.route}`, 'Medicare Allowance');
    setTimeout(() => {
      this.setState({
        animate: 'fadeIn'
      });
    }, 600);
  }

  _handleSelectAllowance (val) {
    const {quiz, stepMethods} = _.clone(this.props);
    let nextStep = quiz.step + 1;

    this.props.reducer(val);
    stepMethods.setStep(nextStep);
  }

  _prevStep () {
    window.history.go(-1);
  }

  render () {
    return (
      <section className={'p30 text-center animate ' + this.state.animate}>
        <div className='wrap'>
          <h3 style={{ maxWidth: 615, margin: '0 auto' }}>When choosing a Medicare plan, which matters more to&nbsp;you?</h3>
          <div className='radio two form'>
            <input type='radio' name='allowance' value='local'
              id='local'
            /><label htmlFor='local'
              onClick={(e) => (this._handleSelectAllowance(1))}>More dental and hearing extras &ndash; even if it means a higher premium</label>
            <input type='radio' name='allowance' value='away'
              id='away'
            /><label
              htmlFor='away'
              style={{display: 'inline-flex', alignItems: 'center'}}
              onClick={(e) => (this._handleSelectAllowance(2))}>Lower monthly premium &ndash; even if it means fewer extras</label>
            <button className='btn back' onClick={this._prevStep}>Previous</button>
          </div>
        </div>
      </section>
    );
  }
}

export default Allowance;
